export const filterElements = {
  region: [
    "West Coast",
    "Southwest",
    "South",
    "Midwest",
    "Southeast",
    "Northeast",
  ],
  position: [
    "Point Guard",
    "Shooting Guard",
    "Small Forward",
    "Power Forward",
    "Center",
  ],
  class: ["2025", "2026", "2027", "2028", "2029", "2030", "2031", "2032"],
  state: [
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusetts",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming",
  ],
};

export const regionToStates = {
  "West Coast": ["California", "Oregon", "Washington"],
  Southwest: ["Arizona", "New Mexico", "Nevada", "Texas"],
  South: ["Texas", "Oklahoma", "Arkansas", "Louisiana"],
  Midwest: [
    "North Dakota",
    "South Dakota",
    "Nebraska",
    "Kansas",
    "Minnesota",
    "Iowa",
    "Missouri",
    "Wisconsin",
    "Illinois",
    "Indiana",
    "Michigan",
    "Ohio",
  ],
  Southeast: [
    "Florida",
    "Georgia",
    "Alabama",
    "South Carolina",
    "North Carolina",
    "Tennessee",
    "Mississippi",
    "Kentucky",
    "Virginia",
    "West Virginia",
  ],
  Northeast: [
    "Maine",
    "New Hampshire",
    "Vermont",
    "Massachusetts",
    "Rhode Island",
    "Connecticut",
    "New York",
    "New Jersey",
    "Pennsylvania",
  ],
};
